"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactNameFromArtifact = exports.ArtifactRarity = exports.ArtifactType = void 0;
/**
 * enum for the type of an artifact.
 */
var ArtifactType;
(function (ArtifactType) {
    ArtifactType[ArtifactType["Unknown"] = 0] = "Unknown";
    ArtifactType[ArtifactType["Monolith"] = 1] = "Monolith";
    ArtifactType[ArtifactType["Colossus"] = 2] = "Colossus";
    ArtifactType[ArtifactType["Spaceship"] = 3] = "Spaceship";
    ArtifactType[ArtifactType["Pyramid"] = 4] = "Pyramid";
    ArtifactType[ArtifactType["Wormhole"] = 5] = "Wormhole";
    ArtifactType[ArtifactType["PlanetaryShield"] = 6] = "PlanetaryShield";
    ArtifactType[ArtifactType["PhotoidCannon"] = 7] = "PhotoidCannon";
    ArtifactType[ArtifactType["BloomFilter"] = 8] = "BloomFilter";
    ArtifactType[ArtifactType["BlackDomain"] = 9] = "BlackDomain";
    ArtifactType[ArtifactType["MIN"] = 1] = "MIN";
    ArtifactType[ArtifactType["MAX"] = 9] = "MAX";
})(ArtifactType = exports.ArtifactType || (exports.ArtifactType = {}));
/**
 * enum for the rarity level of an artifact. Common = 1, Mythic = 5
 */
var ArtifactRarity;
(function (ArtifactRarity) {
    ArtifactRarity[ArtifactRarity["Unknown"] = 0] = "Unknown";
    ArtifactRarity[ArtifactRarity["Common"] = 1] = "Common";
    ArtifactRarity[ArtifactRarity["Rare"] = 2] = "Rare";
    ArtifactRarity[ArtifactRarity["Epic"] = 3] = "Epic";
    ArtifactRarity[ArtifactRarity["Legendary"] = 4] = "Legendary";
    ArtifactRarity[ArtifactRarity["Mythic"] = 5] = "Mythic";
    ArtifactRarity[ArtifactRarity["MIN"] = 1] = "MIN";
    ArtifactRarity[ArtifactRarity["MAX"] = 5] = "MAX";
})(ArtifactRarity = exports.ArtifactRarity || (exports.ArtifactRarity = {}));
// TODO: get this out of here
const godGrammar = {
    god1: [
        "c'",
        'za',
        "ry'",
        "ab'",
        "bak'",
        "dt'",
        "ek'",
        "fah'",
        "q'",
        'qo',
        'van',
        'bow',
        'gui',
        'si',
    ],
    god2: [
        'thun',
        'tchalla',
        'thovo',
        'saron',
        'zoth',
        'sharrj',
        'thulu',
        'ra',
        'wer',
        'doin',
        'renstad',
        'nevere',
        'goth',
        'anton',
        'layton',
    ],
};
/**
 * Deterministically generates the name of the artifact from its ID.
 *
 * @param artifact The artifact to generate a name for
 */
function artifactNameFromArtifact(artifact) {
    const idNum = parseInt(artifact.id, 16);
    const roll1 = (idNum % 7919) % godGrammar.god1.length; // 7919 is a big prime
    const roll2 = (idNum % 7883) % godGrammar.god2.length; // 7883 is a big prime
    const name = godGrammar.god1[roll1] + godGrammar.god2[roll2];
    const nameCapitalized = name.charAt(0).toUpperCase() + name.slice(1);
    return nameCapitalized;
}
exports.artifactNameFromArtifact = artifactNameFromArtifact;
